/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
function MatchHeight() {
  $('.SidebarMenu__Nav .Linklist .Linklist__Item img').matchHeight({});
  $('.SidebarMenu__Nav .coll-menu-img img').matchHeight({});
  // $('.CollectionMain .Grid__Cell').matchHeight({
  //   byRow: true
  // });

}



$(document).ready(function () {

  MatchHeight();
  (document.querySelectorAll('img.svg').forEach(function (img) {
    var imgID = img.id;
    var imgClass = img.className;
    var imgURL = img.src;

    fetch(imgURL).then(function (response) {
      return response.text();
    }).then(function (text) {

      var parser = new DOMParser();
      var xmlDoc = parser.parseFromString(text, "text/xml");

      // Get the SVG tag, ignore the rest
      var svg = xmlDoc.getElementsByTagName('svg')[0];

      // Add replaced image's ID to the new SVG
      if (typeof imgID !== 'undefined') {
        svg.setAttribute('id', imgID);
      }
      // Add replaced image's classes to the new SVG
      if (typeof imgClass !== 'undefined') {
        svg.setAttribute('class', imgClass + ' replaced-svg');
      }

      // Remove any invalid XML tags as per http://validator.w3.org
      svg.removeAttribute('xmlns:a');

      // Check if the viewport is set, if the viewport is not set the SVG wont't scale.
      if (!svg.getAttribute('viewBox') && svg.getAttribute('height') && svg.getAttribute('width')) {
        svg.setAttribute('viewBox', '0 0 ' + svg.getAttribute('height') + ' ' + svg.getAttribute('width'))
      }

      // Replace image with new SVG
      img.parentNode.replaceChild(svg, img);

    });

  }))();

  // if ($('.Grid__Cell.inner--video').length) {
  //   $('.Grid__Cell.inner--video').matchHeight({
  //     byRow: true,
  //   });

  // }


});


$(document).ready(function () {
  $(".HorizontalList > .HorizontalList__Item").mouseover(function () {
    $('.Header').addClass('header-filled');
  });
  $(".HorizontalList > .HorizontalList__Item").mouseout(function () {
    $('.Header').removeClass('header-filled');
  });
  $('#section-header').mouseover(function () {
    $('.Header').addClass('header-filled');
  });
  $('#section-header').mouseout(function () {
    $('.Header').removeClass('header-filled');
  });
})
// let slideIndex = 1;
// showSlide(slideIndex);

// // You are providing the functionality for your clickable content, which is 
// // your previews, dots, controls and the close button.

// function openLightbox() {
//   document.getElementById('Lightbox').style.display = 'block';
// }

// function closeLightbox() {
//   document.getElementById('Lightbox').style.display = 'none';
// };

// // Note that you are assigning new values here to our slidIndex.

// function changeSlide(n) {
//   showSlide(slideIndex += n);
// };

// function toSlide(n) {
//   showSlide(slideIndex = n);
// };
// // This is your logic for the light box. It will decide which slide to show 
// // and which dot is active.

// function showSlide(n) {
//   const slides = document.getElementsByClassName('slide');
//   let modalPreviews = document.getElementsByClassName('modal-preview');

//   if (n > slides.length) {
//     slideIndex = 1;	
//   };

//   if (n < 1) {
//     slideIndex = slides.length;
//   };

//   for (let i = 0; i < slides.length; i++) {
//     slides[i].style.display = "none";
//   };

//   for (let i = 0; i < modalPreviews.length; i++) {
//     modalPreviews[i].className = modalPreviews[i].className.replace(' active', '');
//   };

//   slides[slideIndex - 1].style.display = 'block';
//   modalPreviews[slideIndex - 1].className += ' active';
// };

/**************** lightboxthumbsilder */


// let thumbnails = document.getElementsByClassName('thumbnail')

// 		let activeImages = document.getElementsByClassName('active')

// 		for (var i=0; i < thumbnails.length; i++){

// 			thumbnails[i].addEventListener('mouseover', function(){
// 				console.log(activeImages)

// 				if (activeImages.length > 0){
// 					activeImages[0].classList.remove('active')
// 				}


// 				this.classList.add('active');
//         console.log(this)
// 				document.getElementById('featured').src = this.src

// 			})
// 		}


// let buttonRight = document.getElementById('slideRight');
// let buttonLeft = document.getElementById('slideLeft');

// buttonLeft.addEventListener('click', function(){  
// 	document.getElementById('slider').scrollLeft -= 180
// })

// buttonRight.addEventListener('click', function(){
// 	document.getElementById('slider').scrollLeft += 180
// })

// 18 may 2022 start//
$('.slider_for').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  asNavFor: '.slider_nav',
  accessibility: false,
  responsive: [
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        swipe: true,
        cssEase: 'linear',
        speed: 500,
        asNavFor: '.slider_nav',
      }
    }
  ]
});
$('.slider_nav').slick({
  slidesToShow: 8,
  slidesToScroll: 1,
  asNavFor: '.slider_for',
  dots: false,
  arrows: false,
  infinite: false,
  focusOnSelect: true,
  accessibility: false,
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        centerMode: false,
      }
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 4.5,
        slidesToScroll: 1,
        centerMode: false,
        speed: 1000,
      }
    }
  ]
});



jQuery(function ($) {
  $('.modal').on('shown.bs.modal', function (e) {
    if($('.sliderforproduct.slick-slider').length == 0) {
      $('.sliderforproduct').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        nextArrow: '<button class="slick-next slick-arrow" aria-label="Previous" type="button" style=""><img src="https://cdn.shopify.com/s/files/1/0196/5893/2324/files/suit-next-arrow.svg?v=1729000358"></button>',
        prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><img src="https://cdn.shopify.com/s/files/1/0196/5893/2324/files/suit-prev-arrow.svg?v=1729000358"></button>',
        infinite: false,
        fade: true,
        asNavFor: '.slidernavproduct'
      });
  
      $('.slidernavproduct').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: '.sliderforproduct',
        dots: false,
        arrows: false,
        infinite: false,
        focusOnSelect: true,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              centerMode: false,
            }
          },
          {
            breakpoint: 575,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
              centerMode: false,
            }
          }
        ]
      });
    }
  });

  $(document).on('click','.slider_nav .item',function (e) {
    e.preventDefault();
    var dataslide = $(this).data('slide');
    setTimeout(function () {
      $('.slidernavproduct').slick('slickGoTo', dataslide - 1);
    },500);
  });
    $(document).on('click','.slider_for .item',function (e) {
    e.preventDefault();
    var dataslide = $(this).data('slide');
    setTimeout(function () {
      $('.slidernavproduct').slick('slickGoTo', dataslide - 1);
    },500);
  });
});
// $('.product-slides-modal .sliderforproduct .bg_img').click(function(){ 
//   if ($(this).hasClass("plusactive")) {
//     $(".product-slides-modal .sliderforproduct .bg_img").removeClass("plusactive");
//   }
//   // Else, the element doesn't have the active class, so we remove it from every element before applying it to the element that was clicked
//   else {
//     $('.product-slides-modal .sliderforproduct .bg_img').removeClass("plusactive");
//     $(this).addClass("plusactive");
//   }
//   console.log('add');
// });
// for single image zoom use //
// var el = document.querySelector('.pinch-zoom');
//     new PinchZoom.default(el, {});
////for multipal image zoom use //
 /*Array.from(document.querySelectorAll('.pinch-zoom')).forEach(function(el) {
   new PinchZoom.default(el, {});
 });*/
// 19 july 2022 start//
$('.mob-customize-for').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  asNavFor: '.mob-customize-nav',
  accessibility: false,
});
$('.mob-customize-nav').slick({
  slidesToShow: 4.5,
  slidesToScroll: 1,
  asNavFor: '.mob-customize-for',
  dots: false,
  arrows: false,
  infinite: false,
  focusOnSelect: true,
  accessibility: false,
});
// 14 oct 2022 mob btn stiky start
$(document).ready(function () {
  var div_top = $('.sticky__button').offset().top - 82;

  $(window).scroll(function() {
      var window_top = $(window).scrollTop() - 0;
      if (window_top > div_top) {
          if (!$('.sticky__button').is('.sticky--btn')) {
              $('.sticky__button').addClass('sticky--btn');
              $('.ProductMeta__Tex').addClass('btn-is-sticky');
          }
      } else {
          $('.sticky__button').removeClass('sticky--btn');
          $('.ProductMeta__Tex').removeClass('btn-is-sticky');
      }
  });
});

// 14 oct 2022 mob btn stiky End
$(document).ready(function() {
  var count = $('.Grid__Cell .size-variant-selector__heading').children('.labelall').length
  console.log(count);
    $(document).on('click','.productclick',function(e){
      e.preventDefault();
      var a = $(this).attr('class').split(' ');
      a.forEach( (em,ix) => {
        if( em.toString().indexOf('cc-') !== -1 ){
          a[2] = em.toString();
          return false;
        }
      });
    var b =a[2].split('cc-');
     console.log (b[1]);
        var image = $(this).attr('data-images');
        var url =$(this).attr('data-product-url');
   var secondim =$(this).attr('data-second-img');
   $(".ttt-"+b[1]).attr("src", image);
  $('.changeurl-'+b[1]).attr('href', url);
  $('.gg-'+b[1]).attr('src', secondim);
  $('.cc-'+b[1]+'.active').removeClass('active');
    $(this).addClass('active');
       }); 
        $(document).on('click','.plusvar',function(e){
        e.preventDefault();
         //$('.allprouct').show(); 
          var id = $(this).attr('dataid');
   $(".cc-"+id).show();
   $(".plus-"+id).hide(); 
    });
    }); 


/* 17-11-2022 */ 
$(document).ready(function() {
  $(".mobileimage").each(function(index) {
    $(this).height($(this).next().find('.ProductItem').height());
  });
  $(".desktopimage").each(function(index) {
    $(this).height($(this).next().height());
  });

  /* 21-11-2022 pri */
  $(".desktopvideo").each(function(index) {
    $(this).height($(this).prev().find('.ProductItem').height());
  });

   $(".mobile-video").each(function(index) {
      $(this).height($(this).next().find('.ProductItem').height());
  });
  
  $(window).on('resize',function() {
    $(".mobileimage").each(function(index) {
      $(this).height($(this).next().find('.ProductItem').height());
      console.log($(this).next().find('.ProductItem').height());
    });
    $(".desktopimage").each(function(index) {
      $(this).height($(this).next().height());
    });

    /* 21-11-2022 pri */
     $(".mobile-video").each(function(index) {
      $(this).height($(this).next().find('.ProductItem').height());
  });
    /* 23-11-2022 pri*/
      $(".desktopvideo").each(function(index) {
        $(this).height($(this).prev().find('.ProductItem').height());
      });
  })
})